import { Injectable } from '@angular/core';

@Injectable()
export class FilePicker {
	private sourceFile: any;

	private finalObject = {
		fileName: '',
		fileContent: {}
	};

	public async readFile(event: any): Promise<any> {
		if (!event.target.files[0]) {
			return;
		}

		//TODO: Implement a Validator for the file type etc
		const reader = new FileReader();

		this.sourceFile = event.target.files[0];

		reader.readAsText(this.sourceFile, 'UTF-8');

		this.finalObject.fileName = event.target.files[0].name;

		/* eslint-disable @typescript-eslint/no-unused-vars */
		return await new Promise((resolve, _) => {
			reader.onload = async () => {
				this.finalObject.fileContent = reader.result;
				resolve(this.finalObject);
			};
		});
	}
}
